import React from 'react'
import PropTypes from 'prop-types'
import Text from './Text'
import Signature from './Signature'
import Checkbox from './Checkbox'

export default class Show extends React.Component {
  static propTypes = {
    field: PropTypes.object
  }

  render() {
    const value = this.props.field.value || {}
    if (this.props.field.type === 'text') {
      return <Text value={value.text} field={this.props.field} />
    }
    if (this.props.field.type === 'signature') {
      return <Signature value={value.signatureId} field={this.props.field} />
    }
    if (this.props.field.type === 'checkbox') return <Checkbox value={value.checked} />
    return <span />
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/Field/Show/index.js